import styled from 'styled-components';

export const StyledCreateOfferPage = styled.div`
  width: 100%;
  min-height: calc(100vh - 60px);
  padding: 16px 15px 40px;
  background: var(--white);

  @media (min-width: 1440px) {
    padding: 20px 20px 48px;
  }

  .trial-banner-visible & {
    min-height: calc(100vh - 110px);
  }
`;
